var _circle, _path, _ellipse, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg31(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 800 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 629.5,
    cy: 423.5,
    r: 62.5,
    fill: "#17C7E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M463.092 516.207C415.645 468.368 337.922 468.524 289.495 516.555C241.068 564.585 240.273 642.304 287.721 690.143C335.169 737.982 412.892 737.826 461.319 689.796C509.745 641.765 510.54 564.046 463.092 516.207Z",
    fill: "url(#loaderGradient31)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 520.382,
    cy: 349.673,
    rx: 163,
    ry: 166,
    transform: "rotate(-2.37658 520.382 349.673)",
    fill: "#ED801B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "loaderGradient31",
    x1: 415.999,
    y1: 609.854,
    x2: 253.903,
    y2: 580.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0DB8D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009458"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg31);
export default __webpack_public_path__ + "static/media/31.8a153398389cbe84f7bbeb74f19e1e6677263826ac1814d5912e1477f0669fde.svg";
export { ForwardRef as ReactComponent };